import CopyTextComponent from '../../../../../../ManagementApp/wwwroot/client/src/views/components/CopyText.vue';

export default CopyTextComponent;
